import React, { FC } from "react";
import { useHistory } from "react-router-dom";

import logoIhsm from "../../../assets/images/ihsm_logo.png";

export const UserHome: FC  = () => {
  const history = useHistory();
  return (
    <div className="centerPage">
      <div className="row">
        <div className="col-12 d-flex justify-content-between">
          <h3>Inicio</h3>
        </div>
      </div>
      <div
        className="center flex-column justify-content-around text-center p-5 mt-5"
        style={{ height: "80%" }}
      >
        <img style={{ width: "18vw" }} src={logoIhsm} alt="" />
        <h5 className="text-secondary">
          Te damos la bienvenida al sistema de reservas del Instituto de
          Hortofruticultura Subtropical y Mediterránea La Mayora
        </h5>
        <button className="baseButton" onClick={() => history.push("/reserva")}>Reservar</button>
      </div>
    </div>
  );
};
